export const Currency = {
  Eur: "EUR",
  Gbp: "GBP",
  Usd: "USD",
} as const;
export type Currency = (typeof Currency)[keyof typeof Currency];
export function mapCurrency(currency: string | undefined): Currency {
  if (currency === undefined) {
    return Currency.Eur;
  }
  switch (currency) {
    case Currency.Eur:
      return Currency.Eur;
    case Currency.Gbp:
      return Currency.Gbp;
    case Currency.Usd:
      return Currency.Usd;
    default:
      throw new Error(`Unsupported currency: ${currency}`);
  }
}

/**
 * Currency-specific decimal place configurations.
 * Most currencies use 2 decimal places, but some currencies (like JPY) use 0.
 */
const CURRENCY_DECIMALS: Record<Currency, number> = {
  [Currency.Eur]: 2,
  [Currency.Gbp]: 2,
  [Currency.Usd]: 2,
};

export function getDecimalsForCurrency({
  currency,
  decimalCount = 2,
}: {
  currency?: Currency;
  decimalCount?: number;
}): number {
  // Return currency-specific decimal count if available, otherwise use the provided default
  if (currency && CURRENCY_DECIMALS[currency]) {
    return CURRENCY_DECIMALS[currency];
  }
  return decimalCount;
}
